import { getDeliveryApiBase } from "./deliveryApi";
import { getAdminToken } from "./adminAuth";

function apiBase() {
    const base = getDeliveryApiBase();
    if (!base) {
        throw new Error("MISSING_API");
    }
    return base;
}

async function requestJson(path, { method = "GET", body } = {}) {
    const token = getAdminToken();
    const response = await fetch(`${apiBase()}${path}`, {
        method,
        headers: {
            ...(body ? { "Content-Type": "application/json" } : {}),
            Authorization: `Bearer ${token}`,
        },
        body: body ? JSON.stringify(body) : undefined,
    });
    if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        const error = new Error(payload.error?.message || "REQUEST_FAILED");
        error.status = response.status;
        throw error;
    }
    return response.json().catch(() => ({}));
}

export async function createVideoReview({
    videoPath,
    videoName,
    expiry,
    consent,
    commentVisibility,
}) {
    const data = await requestJson("/api/video-review/create", {
        method: "POST",
        body: { videoPath, videoName, expiry, consent, commentVisibility },
    });
    return data.videoReview;
}

export async function updateVideoReview(id, {
    videoPath,
    videoName,
    expiry,
    consent,
    commentVisibility,
}) {
    await requestJson(`/api/video-review/${encodeURIComponent(id)}`, {
        method: "PUT",
        body: { videoPath, videoName, expiry, consent, commentVisibility },
    });
    return true;
}

export async function listVideoReviews({ page = 1, pageSize = 20, search = "" } = {}) {
    const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
    if (search) {
        params.set("q", search);
    }
    const data = await requestJson(`/api/video-reviews?${params.toString()}`);
    return {
        items: data.videoReviews || [],
        total: Number(data.total) || 0,
        page,
        pageSize,
    };
}

export async function getVideoReview(id) {
    const data = await requestJson(`/api/video-review/${encodeURIComponent(id)}`);
    return data.videoReview || null;
}

export async function deleteVideoReview(id) {
    await requestJson(`/api/video-review/${encodeURIComponent(id)}`, { method: "DELETE" });
    return true;
}

export async function listVideoReviewComments(linkId) {
    const data = await requestJson(
        `/api/video-review/comments?linkId=${encodeURIComponent(linkId)}`
    );
    return data.comments || [];
}

export async function deleteVideoReviewComment({ commentId, linkId }) {
    await requestJson("/api/video-review/comment", {
        method: "DELETE",
        body: { commentId, linkId },
    });
    return true;
}
